<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Main Title Section -->
  <div class="page-title-section">
    <h2>Assurance Prévoyance Décès</h2>
  </div>
  
  <div class="content-section">
    <p>
      Si l'assurance prévoyance décès peut également financer les obsèques, ce n'est pas son seul objectif : elle offre une couverture financière rapide et adaptée aux besoins de vos proches. Le versement d'un capital en cas de décès du souscripteur avant la fin du contrat permet à ses bénéficiaires d'affronter l'avenir plus sereinement.
    </p>
    <p>
      Mais attention, elle ne garantit un capital à ses bénéficiaires qu'en cas de décès (ou d'invalidité totale et irréversible) du souscripteur avant la date de fin du contrat et sous réserve des dispositions contractuelles.
    </p>
    <p>
      Il existe par ailleurs deux types de contrats Prévoyance Capital Décès :
    </p>
    <ul>
      <li>Le contrat de prévoyance capital décès en cas d'accident.</li>
      <li>Le contrat de prévoyance capital décès toutes causes (Accident et Maladies).</li>
    </ul>
    <p>
      Dans tous les cas, le montant des capitaux est généralement plus conséquent bénéficiaire que l'assurance obsèques et permet à ses de l'utiliser bien au-delà du règlement des frais d'obsèques du défunt par exemple pour le règlement des frais de succession ou des dépenses courantes.
    </p>
    <p>
      Une solution qui peut ainsi éviter à vos proches de mettre en vente le bien immobilier dont ils ont reçu pour pouvoir les régler. De plus, le souscripteur est libre à tout moment de modifier les noms des bénéficiaires et le montant du capital garanti si sa situation personnelle évolue (naissance, adoption, mariage, PACS, divorce…).
    </p>
    <p>
      De nombreuses options supplémentaires peuvent s'ajouter afin de bénéficier d'une prévoyance complète comme le doublement du capital versé à vos bénéficiaires en cas de décès accidentel, il faudra bien distinguer le versement par l'assurance Prévoyance Décès, qui elle permet de verser un capital important au bénéficiaire du contrat (le conjoint ou les descendants) en cas de décès de l'assuré, de la prise en charge financière des coûts de funérailles (pompes funèbres, fleurs, inhumation, crémation, etc) par l'Assurance Prévoyance Obsèques dont vous trouverez plus de détails ici.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">OPTION DE CAPITAL "MALADIES REDOUTEES" : définition</h2>
    <p>
      Le capital "maladies redoutées" est une garantie de prévoyance supplémentaire pour votre assurance décès. Si, d'ordinaire, cette assurance permet à vos proches de toucher un capital constitué suite à votre décès, cette garantie vous offre également la possibilité de soutenir financièrement votre famille et votre patrimoine si vous êtes atteint de maladie grave.
    </p>
    <p>
      Bien entendu, la maladie ne doit pas être survenue avant la signature du contrat et le montant du capital varie en fonction de chaque assuré.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">QUELLES PATHOLOGIES SONT PRISES EN COMPTE PAR LE CAPITAL MALADIES REDOUTEES ?</h2>
    <p>
      Par maladies redoutées, on entend les pathologies qui nécessitent un encadrement et un traitement prolongé. Une telle prise en charge représente un coût considérable et peut, du jour au lendemain, bouleverser votre situation financière comme celle de vos proches.
    </p>
    <p>
      Le code des assurances relatif à la garantie maladies redoutées les regroupe de la façon suivante:
    </p>
    <ul>
      <li>Cancer,</li>
      <li>Infarctus,</li>
      <li>Pontage coronarien avec sternotomie,</li>
      <li>Accident vasculaire cérébral avec lésions permanentes,</li>
      <li>Transplantation d'un organe vital,</li>
      <li>Sclérose en plaques,</li>
      <li>Insuffisance rénale nécessitant un traitement par dialyse,</li>
      <li>Maladie de Parkinson,</li>
      <li>Maladie d'Alzheimer.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="purple-title">POURQUOI OPTER POUR UNE GARANTIE MALADIES REDOUTÉES POUR SON ASSURANCE DÉCÈS ?</h2>
    <p>
      Penser à l'assurance décès de son vivant n'est pas toujours chose aisée. Pourtant, en cas de maladie grave, la Sécurité sociale et votre complémentaire santé ne suffisent pas tout le temps à vous protéger. Si une partie de vos soins est assurée, vos indemnités journalières risquent quant à elles de ne pas pallier votre arrêt d'activité, comme le coût de la réorganisation de votre vie quotidienne (aide humaine, aménagement de votre domicile…). Autant de raisons d'anticiper… .
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">QUEL EST LE COÛT D'UNE ASSURANCE DÉCÈS PREVOYANCE ?</h2>
    <p>
      De façon générale, il est conseillé d'assurer un montant équivalent à <strong class="highlight-purple">75% de vos revenus sur trois ans minimum</strong> pour permettre à vos bénéficiaires d'avoir le temps de s'ajuster à la situation sans être financièrement démunis. A titre d'exemple, pour une personne d'une quarantaine d'années, mariée avec deux enfants, et voulant assurer un capital à hauteur de <strong class="highlight-purple">200 000 euros</strong>, les cotisations mensuelles tourneront autour de <strong class="highlight-purple">35/40 euros</strong>. Pour un capital à hauteur de <strong class="highlight-purple">300 000 euros</strong>, elles tourneront autour de <strong class="highlight-purple">45/50 euros</strong>. Et pour un capital à hauteur de <strong class="highlight-purple">400 000 euros</strong>, ces cotisations mensuelles démarreront à <strong class="highlight-purple">60 euros</strong>. Le montant des mensualités varie selon le capital assuré, votre situation familiale, votre âge et votre état de santé.
    </p>
  </div>

  <div class="content-section">
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong class="text-purple">GENERALI, APRIL, AXA SPVIE, SWISSLIFE, MALAKOFF HUMANIS, ALPTIS, POP SANTE, FMA, ASAF & AFPS, HENNER, APIVIA MACIF, AVENIR MUTUELLE, IDENTITE MUTUELLE, UCR, PRAECONIS…</strong>
    </p>
  </div>

  <!-- Devis Button -->
  <div class="devis-button-section">
    <button class="btn-devis-large" (click)="navigateToDevis()">
      Devis en ligne
    </button>
  </div>
</app-page-layout>


